// Small cookie helper for reading/writing cookies (expires in days)
export function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getCookie(name) {
  return document.cookie.split('; ').reduce((r, c) => {
    const [k, v] = c.split('=');
    return k === name ? decodeURIComponent(v) : r;
  }, undefined);
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

// Convenience for consent object
export const CONSENT_COOKIE = 'cenid_cookie_consent';

export function saveConsent(prefObj) {
  try {
    setCookie(CONSENT_COOKIE, JSON.stringify(prefObj), 365);
  } catch (e) {
    console.error('Error saving consent', e);
  }
}

export function loadConsent() {
  try {
    const raw = getCookie(CONSENT_COOKIE);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error('Error loading consent', e);
    return null;
  }
}
